import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { CodeSentScreen } from '../../Auth/CodeSentScreen';
import {CodeSentScreenForgotPassword} from "../../../components/pages/ForgotPassword/CodeSentScreenForgotPassword"; 

import api from '~/services/api';

import {
  FormContainer,
  LoginTitle,
  SignInButton,
  FirstAccessContainer,
} from './styles';

export function TimeExceeded({ handleSubmit, isMFA }) {
  const [isCodeSent, setIsCodeSent] = useState(false);

  const contactId = useSelector((state) => state.tokenReducer.contactId);
  const dispatch = useDispatch();

  async function postToken() {

    dispatch({ type: "SET_INVALID_CODE", invalidCode: false });
    const userId = localStorage.getItem('userId');
    const access_token = localStorage.getItem('access_token');

    const headers = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      access_token,
      client_id: process.env.REACT_APP_CLIENT_ID,
    };

    const body = {
      tokenType: isMFA ? "MFA": "CHANGE_PASSWORD",
      url: 'https://www.frontendtoken.com.br',
      contactId,
    };

    try {
      await api.post(`residential/store/v1/users/${userId}/tokens`, body, { headers });
      setIsCodeSent(true);
    } catch (error) {
      setIsCodeSent(false);
      if(error.status === 401) {
        dispatch({ type: "SET_STEP", step: 0 });
        return
      }
    }
  }

  const TimeExceededContent = () => (
    <>
      <LoginTitle className="mb-3">Tempo excedido!</LoginTitle>
      <LoginTitle className="mb-3">Clique em ”reenviar código” e tente novamente</LoginTitle>
      <SignInButton
        type="submit"
        className="mt-4"
        onClick={postToken}
      >
        <span>Reenviar código</span>
      </SignInButton>
      <FirstAccessContainer
        className="mt-3 w-100"
        onClick={() => {
          if(isMFA) {
            dispatch({ type: "SET_STEP", step: 1 });
          } else {
            dispatch({ type: "SET_STEP", step: 20 });
          }
          
          
          dispatch({ type: "SET_INVALID_CODE", invalidCode: false });
        }}
      >
        <SignInButton outline>
          <span>Tentar de outra maneira</span>
        </SignInButton>
      </FirstAccessContainer>
    </>
  );

  return (
    <>
      {isCodeSent ? (
        isMFA ? (
          <CodeSentScreen handleSubmit={handleSubmit} isMFA={false} />
        ) : (
          <CodeSentScreenForgotPassword />
        )
        ) : (
        isMFA ? (
          <FormContainer>
            <TimeExceededContent />
          </FormContainer>
        ) : (
          <TimeExceededContent />
        )
      )}
    </>
  );
}
